import { Button } from '@/components/ui/button'
import { paths } from '@/configs/paths'
import { logoutApp } from '@/utils/auth'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export default function AccessDenied() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const handleLogout = () => {
    logoutApp()
    navigate(paths.login.path)
  }

  return (
    <div className='flex h-[80vh] w-full flex-col items-center justify-center gap-4'>
      <h1 className='text-4xl font-bold text-gray-900'>403</h1>
      <h2 className='text-2xl font-semibold text-gray-800'>{t('Access Denied' as any)}</h2>
      <p className='text-gray-600'>{t('You do not have permission to view this page.' as any)}</p>
      <div className='flex items-center gap-4'>
        <Button onClick={handleLogout} variant='secondary'>
          {t('Logout' as any)}
        </Button>
        <Button onClick={() => navigate(-1)} variant='default'>
          {t('Go Back' as any)}
        </Button>
      </div>
    </div>
  )
}
